import { Slider } from "@mui/material";
import * as React from "react";
import ReactAudioPlayer from "react-audio-player";
import styled from "styled-components";
export interface SliderProps {
  type: string;
  volumeValue: number;
  handleChange: (event: Event, newValue: number | number[]) => void;
  sourceSound: string;
}

export default function SliderSound({
  type,
  volumeValue = 50,
  handleChange,
  sourceSound,
}: SliderProps) {
  return (
    <>
      <StyledSlideSound className="flex h-10  relative items-center">
        <span className="text-secondary w-28 flex-shrink-0 whitespace-nowrap text-sm font-medium">
          {type}
        </span>
        <div className="w-full flex items-center flex-1">
          <Slider
            onChange={handleChange}
            value={volumeValue}
            min={1}
            className="sound-volume"
            aria-label="Disabled slider"
          />
        </div>
      </StyledSlideSound>
      <ReactAudioPlayer
        volume={volumeValue / 100}
        src={sourceSound}
        autoPlay
        loop
        preload="auto"
      />
    </>
  );
}
const StyledSlideSound = styled.div`
  .sound-volume {
    color: #f3a952;
    height: 8px;
  }

  .MuiSlider-rail {
    color: hsla(0, 0%, 100%, 0.7);
  }
  .track-slider {
    margin-bottom: 0px;
  }
  .MuiSlider-thumb {
    width: 16px;
    height: 16px;
  }
`;
